module.exports = __webpack_public_path__ + "img/4.ec646418.jpg";